module.exports = __webpack_public_path__ + "static/img/turbo-motor_256.f84b6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/turbo-motor_256.png
// module id = fuOc
// module chunks = 0